export default __webpack_public_path__ + "bcacf0954b70609694246036a36e12a4.png";